import React from 'react'
import { Card, CardGroup, Col, Row } from 'react-bootstrap'

const PhotographyReplacement = () => {
  return (
    <>
        <Card className='photography-replacement-container no-border rounded-0 container'>
            <Card className='photography-replacement no-border rounded-0 px-4'>
                <Card.Body>
                    {/* <div className='photography-replacement-title'>Photography Replacement</div> */}
                    <div className='photography-replacement-content'>
                        Ecommerce sales require high - end photography to properly display products for sale.
                        <br />
                        <br /> But those photos don’t have to be taken in a studio — they can be created virtually. Using 3D modeling , we can create photorealistic product shots with all the angles, colors, sizes, and staging you could ever want. 
                        <br />
                        <br /> Let’s think about a furniture company. How much would it cost to bring every couch, chair, table, and other piece — in every color, size, and variation — into the studio to photograph in various arrangements, with different pillows and art pieces? 
                        <br />
                        <br /> That would be time consuming, costly, and likely turn into a bottleneck for getting products listed for sale. 
                        <br />
                        <br /> Photography replacement removes the need for a physical product to create hundreds of image variations for product promotion. With one 3D model of a couch, we can mock up images from different angles, in different product colors, and with different staging setups.
    
                    </div>
                </Card.Body>
            </Card>
            <CardGroup className='photography-replacement-items no-border rounded-0 px-4'>
                <Card className='no-border rounded-0'>
                    <div className='photography-replacement-items-body-1'>
                    <div className='photography-replacement-items-title'>Real Life <br /> Reference Photo</div>
                    </div>
                    <Card.Img className='no-border rounded-0 py-2 photography-replacement-items-image' src={process.env.PUBLIC_URL + "assets/photography/chair1.jpg"} />
                </Card>
                <Card className='no-border rounded-0'>
                    <div className='photography-replacement-items-body-2'>
                    <div className='photography-replacement-items-title'>Artist Created <br /> 3D Model </div>
                    </div>
                    <Card.Img className='no-border rounded-0 py-2 photography-replacement-items-image1' src={process.env.PUBLIC_URL + "assets/photography/chair2.jpg"} />
                </Card>
                <Card className='no-border rounded-0'>
                    <div className='photography-replacement-items-body-3'>
                    <div className='photography-replacement-items-title'>Rendered Virtual Image <br />  From 3D Model</div>
                    </div>
                    <Card.Img className='no-border rounded-0 py-2 photography-replacement-items-image2' src={process.env.PUBLIC_URL + "assets/photography/chair3.jpg"} />
                </Card>
            </CardGroup>
        </Card>
        <Card className='no-border rounded-0 container'>
            <Card.Title className='fw-bold p-3 mb-4 text-center'>Benefits of photography replacement:</Card.Title>
            <Row className='mb-4'>
                <Col xs={{span:12, offset:0}} md={{span:6, offset:0}} className='mb-4'>
                    <Row>
                        <Col xs={{span:2, offset:0}} className="">
                            <Card.Img className='photography-icon align-self-end' src={process.env.PUBLIC_URL + "assets/icons/p_001.png"} alt="" />
                        </Col>
                        <Col xs={{span:10, offset:0}}>
                            <Card.Text className='photography-benifit-text'>
                            High - detail outputs - Viewers can see and almost feel the wood grain or fabric texture
                            </Card.Text>
                        </Col>
                    </Row>
                </Col>
                <Col xs={{span:12, offset:0}} md={{span:6, offset:0}} className='mb-4'>
                    <Row>
                        <Col xs={{span:2, offset:0}} className="">
                            <Card.Img className='photography-icon align-self-end' src={process.env.PUBLIC_URL + "assets/icons/p_002.png"} alt="" />
                        </Col>
                        <Col xs={{span:10, offset:0}}>
                            <Card.Text className='photography-benifit-text'>
                            More control - Photo shoots can be derailed by shipping delays, weather, personnel issues, and more — but not photography replacement
                            </Card.Text>
                        </Col>
                    </Row>
                </Col>
                <Col xs={{span:12, offset:0}} md={{span:6, offset:0}} className='mb-4'>
                    <Row>
                        <Col xs={{span:2, offset:0}} className="">
                            <Card.Img className='photography-icon align-self-end' src={process.env.PUBLIC_URL + "assets/icons/p_003.png"} alt="" />
                        </Col>
                        <Col xs={{span:10, offset:0}}>
                            <Card.Text className='photography-benifit-text'>
                            Image variety - Shoppers want to see products in a realistic environment, not against a white backdrop, and photo replacement allows accessories and backgrounds to be added quickly
                            </Card.Text>
                        </Col>
                    </Row>
                </Col>
                <Col xs={{span:12, offset:0}} md={{span:6, offset:0}} className='mb-4'>
                    <Row>
                        <Col xs={{span:2, offset:0}} className="">
                            <Card.Img className='photography-icon align-self-end' src={process.env.PUBLIC_URL + "assets/icons/p_004.png"} alt="" />
                        </Col>
                        <Col xs={{span:10, offset:0}}>
                            <Card.Text className='photography-benifit-text'>
                            No inventory needed - Many ecommerce companies don’t move products through the same location where their website team resides, and with photography replacement, products don’t need to be rerouted and marked “used” for photoshoots
                            </Card.Text>
                        </Col>
                    </Row>
                </Col>
                <Col xs={{span:12, offset:0}} md={{span:6, offset:0}} className='mb-4'>
                    <Row>
                        <Col xs={{span:2, offset:0}} className="">
                            <Card.Img className='photography-icon align-self-end' src={process.env.PUBLIC_URL + "assets/icons/p_005.png"} alt="" />
                        </Col>
                        <Col xs={{span:10, offset:0}}>
                            <Card.Text className='photography-benifit-text'>
                            3D options - Because we build images with 3D modeling, sellers can offer 3D product views for customers to enjoy before purchase
                            </Card.Text>
                        </Col>
                    </Row>
                </Col>
                
            </Row>
        </Card>
    </>
  )
}

export default PhotographyReplacement
